class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    if (window.atomCartDrawerSyncDiscountUi) window.atomCartDrawerSyncDiscountUi({ quiet: true });
    const wasActive = this.classList.contains('active');
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    let focusIsTrapped = false;
    const trapDrawerFocus = () => {
      if (focusIsTrapped) return;
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      if (!containerToTrapFocusOn || !focusElement) return;
      focusIsTrapped = true;
      trapFocus(containerToTrapFocusOn, focusElement);
    };

    if (wasActive) {
      setTimeout(trapDrawerFocus);
    } else {
      this.addEventListener('transitionend', trapDrawerFocus, { once: true });
      setTimeout(trapDrawerFocus, 430);
    }

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections && parsedState.sections[section.id];
      if (!sectionHtml) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      const sectionInnerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (!sectionInnerHTML) return;
      sectionElement.innerHTML = sectionInnerHTML;
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const sectionElement = new DOMParser().parseFromString(html || '', 'text/html').querySelector(selector);
    return sectionElement ? sectionElement.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

(function () {
  'use strict';

  var warmed = false;
  var navigating = false;
  var CHECKOUT_SYNC_TIMEOUT = 4000;
  var FAST_ADD_OPEN_DELAY = 70;
  var CHECKOUT_SELECTOR = '[data-cart-drawer-checkout]';
  var DISCOUNT_STORAGE_KEY = 'atomCartDrawerDiscountCode';

  function getFetchPath(input) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return url.split('?')[0].split('#')[0];
    }
  }

  function isCartAddFetch(input, init) {
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    return method !== 'GET' && /\/cart\/add(?:\.js)?$/.test(getFetchPath(input));
  }

  function fastOpenTrigger() {
    var active = document.activeElement;
    return active && active.closest ? active.closest('button, [href], input, select, textarea, [tabindex]') : null;
  }

  function scheduleFastAddDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function' || drawer.classList.contains('active')) return null;
    if (document.querySelector('quick-add-modal[open], quick-add-modal[aria-modal="true"]')) return null;

    var state = { opened: false, timer: null };
    var trigger = fastOpenTrigger();
    state.timer = window.setTimeout(function () {
      var currentDrawer = document.querySelector('cart-drawer');
      if (!currentDrawer || typeof currentDrawer.open !== 'function' || currentDrawer.classList.contains('active')) return;
      state.opened = true;
      currentDrawer.open(trigger);
    }, FAST_ADD_OPEN_DELAY);

    return state;
  }

  function closeFastOpenedDrawer(state) {
    if (!state) return;
    window.clearTimeout(state.timer);
    if (!state.opened) return;

    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') drawer.close();
  }

  function wireFastAddDrawerOpen() {
    if (window.__atomCartDrawerFastAddOpenWired || typeof window.fetch !== 'function') return;
    window.__atomCartDrawerFastAddOpenWired = true;

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var shouldFastOpen = isCartAddFetch(input, init);
      var fastOpenState = shouldFastOpen ? scheduleFastAddDrawerOpen() : null;
      var request = originalFetch.apply(this, arguments);

      if (shouldFastOpen && request && typeof request.then === 'function') {
        request.then(function (response) {
          if (response && !response.ok) closeFastOpenedDrawer(fastOpenState);
        }).catch(function () {
          closeFastOpenedDrawer(fastOpenState);
        });
      }

      return request;
    };
  }

  // wireFastAddDrawerOpen();  // DISABLED 2026-06-03 — this optimistic 70ms "fast open"
  // showed the drawer with STALE content before /cart/add resolved, then the product form
  // (main add) or atom-cart-sync.js (Selleasy / app adds) re-rendered + re-opened it with
  // FRESH content — a visible double-open flash. Both of those paths already open the drawer
  // exactly once, with fresh content. Function kept above for easy re-enable. Audit 2026-06-03.

  function warmCheckoutConnections() {
    if (warmed) return;
    warmed = true;

    [
      'https://cdn.shopify.com',
      'https://shop.app',
      'https://pay.google.com',
      'https://www.paypal.com',
      'https://c.paypal.com',
    ].forEach(function (origin) {
      if (document.querySelector('link[rel="preconnect"][href="' + origin + '"]')) return;
      var link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = origin;
      if (origin === 'https://cdn.shopify.com') link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }

  function setCheckoutBusy(button, commit) {
    if (!button) return;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    if (!commit) return;
    if (!button.getAttribute('data-checkout-label')) {
      button.setAttribute('data-checkout-label', button.textContent.trim());
    }
    button.textContent = 'Opening checkout...';
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
  }

  function clearCheckoutBusy() {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (button) {
      var label = button.getAttribute('data-checkout-label');
      if (label) button.textContent = label;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      button.disabled = false;
    });
  }

  function getStoredDiscountCode() {
    try {
      return window.sessionStorage.getItem(DISCOUNT_STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function setStoredDiscountCode(code) {
    try {
      if (code) {
        window.sessionStorage.setItem(DISCOUNT_STORAGE_KEY, code);
      } else {
        window.sessionStorage.removeItem(DISCOUNT_STORAGE_KEY);
      }
    } catch (e) {}
  }

  function getDiscountRoot() {
    return document.querySelector('[data-cart-drawer-discount]');
  }

  function getDiscountInput() {
    var root = getDiscountRoot();
    return root ? root.querySelector('[data-cart-discount-input]') : null;
  }

  function getCurrentDiscountCode() {
    var input = getDiscountInput();
    return input ? input.value.trim() : getStoredDiscountCode();
  }

  function syncDiscountUi(options) {
    options = options || {};
    var root = getDiscountRoot();
    if (!root) return;

    var code = getStoredDiscountCode();
    var input = root.querySelector('[data-cart-discount-input]');
    var label = root.querySelector('[data-cart-discount-label]');
    var status = root.querySelector('[data-cart-discount-status]');

    if (input && !options.preserveInput) input.value = code;
    if (label) {
      label.textContent = code;
      label.hidden = !code;
    }
    if (status && !options.quiet) {
      status.textContent = code ? 'Code saved for checkout.' : 'Discount code cleared.';
    }
  }

  window.atomCartDrawerSyncDiscountUi = syncDiscountUi;

  function checkoutUrl() {
    var code = getCurrentDiscountCode();
    if (!code) return '/checkout';
    setStoredDiscountCode(code);
    return '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  }

  function normaliseQuantity(input) {
    var quantity = parseInt(input.value, 10);
    if (Number.isNaN(quantity) || quantity < 0) quantity = 0;
    input.value = quantity;
    return quantity;
  }

  function getLineKey(input) {
    var item = input.closest('[data-key]');
    return item ? item.getAttribute('data-key') : '';
  }

  function buildCartUpdatePayload(form) {
    if (!form) return null;

    var payload = {};
    var updates = {};
    var hasUpdates = false;

    form.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      var key = getLineKey(input);
      if (!key) return;

      var quantity = normaliseQuantity(input);
      var initialQuantity = parseInt(input.defaultValue || input.getAttribute('value') || '0', 10);
      if (Number.isNaN(initialQuantity)) initialQuantity = 0;
      if (quantity === initialQuantity) return;

      updates[key] = quantity;
      hasUpdates = true;

      // Globo merged display: the parent row carries the hidden companion add-on keys
      // (comma-joined; cable + controller can coexist) — sync them or a fast checkout
      // after a qty edit sends parent/companion out of step.
      var companionRow = input.closest('[data-key]');
      var companionKeys = companionRow ? companionRow.getAttribute('data-companion-key') : '';
      if (companionKeys) {
        companionKeys.split(',').forEach(function (k) {
          if (k) updates[k] = quantity;
        });
      }
    });

    if (hasUpdates) payload.updates = updates;

    var note = form.querySelector('[name="note"]');
    if (note && note.value !== note.defaultValue) {
      payload.note = note.value;
    }

    return Object.keys(payload).length ? payload : null;
  }

  function syncCartForCheckout(form) {
    var payload = buildCartUpdatePayload(form);
    if (!payload) return Promise.resolve();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
      credentials: 'same-origin',
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart drawer update failed');
      return response.json();
    });
  }

  // Resolves on successful cart write; REJECTS on error OR timeout so
  // checkout fails CLOSED (never navigates to /checkout with a stale cart).
  function withCheckoutTimeout(promise) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error('checkout-sync-timeout'));
      }, CHECKOUT_SYNC_TIMEOUT);

      promise.then(
        function (value) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          resolve(value);
        },
        function (err) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          reject(err || new Error('checkout-sync-failed'));
        }
      );
    });
  }

  // Show a brief error on the checkout button and reset state so the user
  // can retry. Mirrors the PDP ATC error pattern (atom-product-main.liquid).
  function failCheckout(button) {
    navigating = false;
    var targets = button ? [button] : document.querySelectorAll(CHECKOUT_SELECTOR);
    var list = button ? targets : Array.prototype.slice.call(targets);
    list.forEach(function (b) {
      if (!b) return;
      var label = b.getAttribute('data-checkout-label');
      b.classList.remove('is-loading');
      b.removeAttribute('aria-busy');
      b.removeAttribute('aria-disabled');
      b.disabled = false;
      if (!b.getAttribute('data-checkout-error-label')) {
        b.setAttribute('data-checkout-error-label', label || b.textContent.trim());
      }
      b.textContent = "Couldn’t update — try again";
      b.classList.add('is-error');
      window.setTimeout(function () {
        var restore = b.getAttribute('data-checkout-error-label');
        if (restore) b.textContent = restore;
        b.classList.remove('is-error');
        b.removeAttribute('data-checkout-error-label');
      }, 1800);
    });
  }

  function openCheckout() {
    window.location.assign(checkoutUrl());
  }

  function goToCheckout(button) {
    if (navigating) return;
    navigating = true;

    var form = document.getElementById('CartDrawer-Form');
    warmCheckoutConnections();
    setCheckoutBusy(button, true);

    if (!buildCartUpdatePayload(form)) {
      openCheckout();
      return;
    }

    withCheckoutTimeout(syncCartForCheckout(form)).then(openCheckout, function () {
      failCheckout(button);
    });
  }

  function checkoutButtonFromEvent(event) {
    return event.target && event.target.closest ? event.target.closest(CHECKOUT_SELECTOR) : null;
  }

  document.addEventListener('input', function (event) {
    if (!event.target || !event.target.matches('[data-cart-discount-input]')) return;
    setStoredDiscountCode(event.target.value.trim());
    syncDiscountUi({ preserveInput: true, quiet: true });
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-cart-discount-apply]') : null;
    if (!button) return;
    event.preventDefault();

    var input = getDiscountInput();
    var code = input ? input.value.trim() : '';
    setStoredDiscountCode(code);
    syncDiscountUi({ quiet: false });
    if (input) input.value = code;
  });

  document.addEventListener('click', function (event) {
    var summary = event.target && event.target.closest
      ? event.target.closest('[data-cart-drawer-discount] > summary')
      : null;
    if (!summary) return;

    window.setTimeout(function () {
      var root = getDiscountRoot();
      var input = getDiscountInput();
      if (!root || !root.open || !input) return;
      syncDiscountUi({ preserveInput: true, quiet: true });
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        try {
          input.focus({ preventScroll: false });
        } catch (e) {
          input.focus();
        }
      }
    }, 80);
  });

  syncDiscountUi({ quiet: true });

  document.addEventListener('pointerenter', function (event) {
    if (checkoutButtonFromEvent(event)) warmCheckoutConnections();
  }, true);

  document.addEventListener('focusin', function (event) {
    if (checkoutButtonFromEvent(event)) warmCheckoutConnections();
  });

  document.addEventListener('pointerdown', function (event) {
    var button = checkoutButtonFromEvent(event);
    if (!button) return;
    warmCheckoutConnections();
    setCheckoutBusy(button, false);
  }, true);

  document.addEventListener('touchstart', function (event) {
    var button = checkoutButtonFromEvent(event);
    if (!button) return;
    warmCheckoutConnections();
    setCheckoutBusy(button, false);
  }, { capture: true, passive: true });

  document.addEventListener('click', function (event) {
    var button = checkoutButtonFromEvent(event);
    if (!button) return;
    event.preventDefault();
    goToCheckout(button);
  }, true);

  document.addEventListener('submit', function (event) {
    if (event.target && event.target.id !== 'CartDrawer-Form') return;
    var button = event.submitter || document.querySelector(CHECKOUT_SELECTOR);
    if (!button || !button.matches(CHECKOUT_SELECTOR)) return;
    event.preventDefault();
    goToCheckout(button);
  }, true);

  window.addEventListener('pageshow', function (event) {
    navigating = false;
    clearCheckoutBusy();
    if (event.persisted) window.location.reload();
  });

  window.addEventListener('pagehide', clearCheckoutBusy);
})();
